import { render, staticRenderFns } from "./ImageResultsTable.vue?vue&type=template&id=6412218e&scoped=true&"
import script from "./ImageResultsTable.vue?vue&type=script&lang=ts&"
export * from "./ImageResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ImageResultsTable.vue?vue&type=style&index=0&id=6412218e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6412218e",
  null
  
)

export default component.exports